import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/2 does this sound familiar/webp/cloud.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/3 Lets get sleeping/baby bear 2.png");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPromotionSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/BlogPromotionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstagramSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/InstagramSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IssueTag"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/IssueTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LastCTAv2"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/LastCTAv2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionBridgeSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/SolutionBridgeSection.tsx");
